Shopify.queryParams = {};

/**
 * Refresh the collection page with the provided filters.
 * 
 * @param {string} url_filters - The URL parameters for the filters.
 */
function refreshCollectionPageWithFilters(url_filters) {
    let currentUrl = '//' + location.host + location.pathname;
    let newPageString = httpGet(currentUrl + '?' + url_filters);
    let newPageEl = document.createElement('DIV');
    newPageEl.innerHTML = newPageString;

    var newSection = newPageEl.querySelector('.mm-collection-grid');
    var activeFilters = newPageEl.querySelectorAll('.active-filters');

    document.querySelector('.mm-collection-grid').innerHTML = newSection.innerHTML;

    activeFilters.forEach(function (activeFilter) {
        var newActiveFilters = document.querySelectorAll('.active-filters');
        newActiveFilters.forEach(function (newActiveFilter) {
            newActiveFilter.innerHTML = activeFilter.innerHTML;
        });
    });

    if (window.innerWidth < 900) {
        var newNumMobile = newPageEl.querySelector('.mm-num-active-filter');
        document.querySelector('.mm-num-active-filter').innerHTML = newNumMobile.innerHTML;
    }

    window.history.replaceState(null, document.title, currentUrl + '?' + url_filters);
}

/**
 * Perform a synchronous GET request.
 * 
 * @param {string} theUrl - The URL to request.
 * @returns {string} - The response text from the request.
 */
function httpGet(theUrl) {
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', theUrl, false);
    xmlHttp.send(null);
    return xmlHttp.responseText;
}

/**
 * Check for changes in the filter inputs and submit the form if changes are detected.
 */
function checkForChanges() {
    var form = document.getElementById('collectionFacetsForm');
    var inputs = form.querySelectorAll('input');

    inputs.forEach(function (input) {
        input.addEventListener('change', function () {
            fakeSubmitForm();
            // mmInitSplide();
        });
    });
}

/**
 * Adds an event listener to all elements with the class 'sort_by'.
 * When the value of a 'sort_by' element changes, it updates the sort_by query parameter
 * in the URL and reloads the page with the new sorting applied.
 */
document.querySelector('.sort_by').addEventListener('change', function(e) {
	var value = e.target.value;
	Shopify.queryParams.sort_by = value;
	location.search = new URLSearchParams(Shopify.queryParams).toString();
});

/**
 * Serialize the form data and refresh the collection page with the filters.
 */
function fakeSubmitForm() {
    let url_filters = $('#collectionFacetsForm').serialize();
    refreshCollectionPageWithFilters(url_filters);
}

// Functions for handling mobile filter drawer
if (window.innerWidth < 900) {
    /**
     * Open the mobile filters drawer.
     */
    function mmOpenFiltersMobile() {
        var header = document.querySelector('header');
        var wrapperMobile = document.querySelector('.mm-filters-container');
        wrapperMobile.style.top = header.getBoundingClientRect().bottom + 'px';
        wrapperMobile.style.height = 'calc(var(--doc-height) - ' + header.getBoundingClientRect().bottom + 'px)';
        wrapperMobile.classList.add('mm-open');

        document.querySelector('html').classList.add('stop-scrolling');
    }

    /**
     * Close the mobile filters drawer.
     */
    function mmCloseFiltersMobile() {
        var wrapperMobile = document.querySelector('.mm-filters-container');
        wrapperMobile.classList.remove('mm-open');

        document.querySelector('html').classList.remove('stop-scrolling');
    }

    /**
     * Check if the URL contains the 'open_filters' parameter and open the mobile filters drawer if it does.
     */
    function mmCheckDrawer() {
        var currentUrl = document.location.href.indexOf('?open_filters');
        if (currentUrl !== -1) {
            mmOpenFiltersMobile();
        }
    }
}


// Fonction pour Sort by
function checkSortByParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortByValue = urlParams.get('sort_by');
    const selectElement = document.getElementById('sort-by');

    if (sortByValue) {
        // Si "sort_by" présent, sélectionner le tri correspondant
        selectElement.value = sortByValue;
    } else {
        // Sinon, afficher "Trier par:"
        selectElement.selectedIndex = 0;
    }
}

document.addEventListener('DOMContentLoaded', checkSortByParam);


// Modification de la grille selon le filtre
document.addEventListener('DOMContentLoaded', function() {
    const filterPills = document.querySelectorAll('.mm-collection-filter-pill');
    const productCards = document.querySelectorAll('.mm-collection-product-card');

    filterPills.forEach(function(pill) {
        pill.addEventListener('click', function() {
            const selectedColor = pill.getAttribute('data-color').trim();

            filterPills.forEach(p => p.classList.remove('mm-active'));
            pill.classList.add('mm-active');

            productCards.forEach(function(card) {
                const cardColors = card.getAttribute('data-colors')
                                    .split(',')
                                    .map(c => c.trim());

                if (selectedColor === 'all' || cardColors.includes(selectedColor)) {
                    card.style.display = 'block';
                } else {
                    card.style.display = 'none';
                }
            });
        });
    });
});


// Gestion des breaking blocs
document.addEventListener('DOMContentLoaded', function() {
    const filterPills = document.querySelectorAll('.mm-collection-filter-pill');
    const productCards = document.querySelectorAll('.mm-collection-product-card');
    const breakingBlocsDesktop = document.querySelectorAll('.mm-collection-bb-icone-text');
    const breakingBlocsMobile1 = document.querySelectorAll('.mm-collection-bb-icone-text');
    const breakingBlocsMobile2 = document.querySelectorAll('.mm-collection-bb-icone-text-mobile');

    function countVisibleProducts() {
        return Array.from(productCards).filter(card => card.style.display !== 'none').length;
    }

    function toggleBreakingBlocs() {
        const visibleProductCount = countVisibleProducts();

        if (window.innerWidth > 768) {
            // Desktop
            breakingBlocsDesktop.forEach(block => {
                block.style.display = (visibleProductCount > 4) ? 'flex' : 'none';
            });
        } else {
            // Mobile
            breakingBlocsMobile1.forEach(block => {
                block.style.display = (visibleProductCount > 4) ? 'flex' : 'none';
            });
            breakingBlocsMobile2.forEach(block => {
                block.style.display = (visibleProductCount > 6) ? 'flex' : 'none';
            });
        }
    }

    function filterProducts(selectedColor) {
        productCards.forEach(function(card) {
            const cardColors = card.getAttribute('data-colors').split(',').map(c => c.trim());
            card.style.display = (selectedColor === 'all' || cardColors.includes(selectedColor)) ? 'block' : 'none';
        });

        // Nombre de produits visibles après filtrage
        toggleBreakingBlocs();
    }

    filterPills.forEach(function(pill) {
        pill.addEventListener('click', function() {
            const selectedColor = pill.getAttribute('data-color').trim();

            filterPills.forEach(p => p.classList.remove('mm-active'));
            pill.classList.add('mm-active');

            filterProducts(selectedColor);
        });
    });

    // Exécute au chargement de la page
    toggleBreakingBlocs();

    // Pour le redimensionnement
    window.addEventListener('resize', toggleBreakingBlocs);
});

// Filtres de scroll
document.addEventListener('DOMContentLoaded', function() {
    const filterPills = document.querySelector('.mm-collection-filter-pills');
    const form = document.querySelector('.filter-form');
    let isScrolling;
    
    filterPills.addEventListener('scroll', function() {
        window.clearTimeout(isScrolling);

        // Grandient de gauche
        if (filterPills.scrollLeft > 0) {
            form.classList.add('scrolling-left');
        } else {
            form.classList.remove('scrolling-left');
        }

        isScrolling = setTimeout(function() {
            filterPills.classList.remove('scrolling-right');
        }, 100);
    });
});